let parameters = {
    backgroundColorSource: {
        label: 'Theme',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemText: 'name',
        itemValue: 'id',
        items: [],
        wait: true
    },
    formSchema: {
        label: 'Schema',
        class: 'xs12 sm12 d-flex',
        type: 'textarea',
        wait: true
    },
    backgroundColor: {
        label: 'ThemeColor',
        class: 'xs12 sm12 d-flex',
        type: 'theme-color',
        source: 'parameters.themeDataSource.item.data',
        itemText: 'name',
        itemValue: 'id',
        items: [],
        wait: true,
        value: []
    }
};

export default parameters;